import { Accordion, AccordionDetail, AccordionHeader, AccordionItem, AccordionTitle } from "@vds/accordions";
import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { Body, Title } from "@vds/typography";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearDetailNavSource } from "../../hooks/usePaginationReset";
import { CHART_TYPE_OPTIONS, CHART_TYPE_LABELS } from "../Statistics/statisticsConstants";

const UserSettings = () => {
  const dispatch = useDispatch();
  const chartType = useSelector((state) => state.userAppSettingsReducer.StatisticsCharts.chart);
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [pendingChartType, setPendingChartType] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    clearDetailNavSource();
  }, []);

  const handleChartTypeChange = (e) => {
    const selected = e.target.value;
    if (selected !== chartType) {
      setPendingChartType(selected);
      setShowConfirmModal(true);
    }
  };

  const handleConfirm = () => {
    dispatch({ type: "SET_STATISTICS_CHART_TYPE", payload: pendingChartType });
    setShowConfirmModal(false);
    setPendingChartType(null);
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
    setPendingChartType(null);
  };

  return (
    <div data-testid="user-settings-page">
      <div style={{ padding: "16px 0px 24px" }}>
        <Title bold={true} size="large" data-testid="user-settings-page-title">
          User Settings
        </Title>
      </div>

      <Accordion>
        <AccordionItem opened={accordionOpen}>
          <AccordionHeader
            triggerType="icon"
            onClick={() => setAccordionOpen((prev) => !prev)}
            data-testid="user-settings-statistics-chart-type-accordion-header"
          >
            <AccordionTitle>Statistics Chart Type</AccordionTitle>
          </AccordionHeader>
          <AccordionDetail>
            <div style={{ padding: "12px 0px" }}>
              <RadioButtonGroup
                data-testid="user-settings-chart-type-radio-group"
                value={chartType}
                data={CHART_TYPE_OPTIONS}
                onChange={handleChartTypeChange}
              />
            </div>
          </AccordionDetail>
        </AccordionItem>
      </Accordion>

      <Modal
        opened={showConfirmModal}
        disableOutsideClick={true}
        ariaLabel="Confirm chart type switch"
        hideCloseButton={true}
        data-testid="user-settings-confirm-chart-type-modal"
      >
        <ModalBody>
          <Body size="large" viewport="desktop" primitive="p">
            Are you sure you want to switch to{" "}
            <strong>{CHART_TYPE_LABELS[pendingChartType]}</strong>?
          </Body>
        </ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              children: "Yes",
              onClick: handleConfirm,
              "data-testid": "user-settings-confirm-chart-type-yes"
            },
            close: {
              children: "Cancel",
              onClick: handleCancel,
              "data-testid": "user-settings-confirm-chart-type-cancel"
            }
          }}
        />
      </Modal>
    </div>
  );
};

export default UserSettings;
